// @flow
import React from "react"
import type { Node } from "react"

import Button from "../Button/Button"
import Translate from "../../../../app/scripts/components/Translate"

type Props = {
  onClose: () => void,
  children: Node,
}

const Modal = ({ onClose, children }: Props) => (
  <div className="InfoModal">
    <div className="InfoModal-text">{children}</div>
    <div className="InfoModal-actions">
      <Button onClick={onClose} fullwidth>
        <Translate tKey="common.ok" />
      </Button>
    </div>
  </div>
)

export default Modal
